import React from 'react';
import { useParams } from "react-router-dom";
import { connect } from 'react-redux';
import { Routes, Route } from 'react-router-dom';

import withRouter from '../../withRouter';
import { ADMSPanel } from '../adms/ADMSPanel';

import { factory } from '../../components/adms/Providers';
import { AdmsRepository, SkosRepository, VocabsIndividual, VocabsRepository } from '../../redux/index';
import SettingsActions from '../../redux/SettingsActions';


import {
  AssetListView, AssetCardView,
  SKSAOntologyView,
  SubjectCardView,
  ConceptSchemeListView, ConceptSchemeCardView,
  ValuesVocabsListView, IndividualCardView,
  XSDViewer,
  SKSACatalogCardView
} from '../../views/containers';


class ADMSPanelProxy extends ADMSPanel {

  constructor(props) {
    super(props);

    this.prevGraph = undefined;
    this.prevCatalog = undefined;
    this.prevLang = undefined;
  }

  beforeLoadAdmsOntology() {
    console.log("beforeLoadAdmsOntology", this);
    const { graph, catalog, lang } = this.props;

    this.prevGraph = graph;
    this.prevCatalog = catalog;
    this.prevLang = lang;

    return Promise.resolve()
      .then(() => {
        if (this.props.adminGraph && this.props.adminCatalog) {
          return Promise.all([
            this.props.dispatch(AdmsRepository.swithCatalog(this.props.adminCatalog, this.props.adminGraph)),
            this.props.dispatch(SkosRepository.EMPTY()),
            this.props.dispatch(VocabsRepository.EMPTY())
          ]);
        }
      })
      .then(() => {
        if (this.props.adminLang) {
          return this.props.dispatch(
            SettingsActions.SET_LANG(this.props.adminLang)
          );
        }
      });
  }

  afterUnmountAdmsPanel() {
    console.log("afterUnmountAdmsPanel", this);
    return Promise.resolve()
      .then(() => {
        if (this.prevGraph && this.prevCatalog) {
          return Promise.all([
            this.props.dispatch(AdmsRepository.swithCatalog(this.prevCatalog, this.prevGraph)),
            this.props.dispatch(SkosRepository.EMPTY()),
            this.props.dispatch(VocabsRepository.EMPTY())
          ]);
        }
      })
      .then(() => {
        if (this.prevLang) {
          return this.props.dispatch(
            SettingsActions.SET_LANG(this.prevLang)
          );
        }
      });
  }

  getBaseRoutePath = (path = "") => {
    const { adminCatalog, adminGraph } = this.props;

    return (
      "/catalog/" +
      encodeURIComponent(adminCatalog) +
      "/" +
      encodeURIComponent(adminGraph) +
      (path ? "/" + path : "")
    );
  }

  renderRoutes() {
    return (
      <Routes>
        <Route path="adms/:id" element={<AssetCardView factory={factory} getBaseRoutePath={this.getBaseRoutePath}/>}></Route>
        <Route path="xsd/:id" element={<XSDViewer factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>            
        <Route path="skos/:id" element={<ConceptSchemeCardView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>            
        <Route path="schemes" element={<ConceptSchemeListView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>            
        <Route path="sksaowl" element={<SKSAOntologyView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
        <Route path="sksaowl/:id" element={<SKSAOntologyView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
        <Route path="catalog/:id/*" element={<AssetListView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
        <Route path="vocabs" element={<ValuesVocabsListView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
        <Route path="individual/:id" element={<IndividualCardView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>              
        <Route path="subject/:id" element={<SubjectCardView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
        <Route path="subject/*" element={<SubjectCardView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
        <Route path="*" element={<AssetListView factory={factory} getBaseRoutePath={this.getBaseRoutePath} />}></Route>
      </Routes>
    );
  }
}

function mapStateToProps(state, props) {
  const { vset, linker } = state;
  const { catalog, graph} = AdmsRepository.currentCatalog();
  return {
    graph: props.graph ? props.graph : graph,
    catalog: props.catalog ? props.catalog : catalog,
    lang: props.lang ? props.lang : vset.lang,

    adminGraph: props.adminGraph,
    adminCatalog: props.adminCatalog,
    adminLang: props.adminLang,

    pch: vset.pch && (
      vset.pch.toLowerCase() === 'yes' ||
      vset.pch.toLowerCase() === 'default'
    ),

    linker
  };
}

const ADMSPanelProxyConnected = withRouter(connect(mapStateToProps)(ADMSPanelProxy));

const ADMSPanelProxyRoute = () => {
  const params = useParams();

  const catalog = params.catalog
    ? decodeURIComponent(params.catalog)
    : undefined;

  const graph = params.graph
    ? decodeURIComponent(params.graph)
    : undefined;

  return (
    <> 
      <SKSACatalogCardView  adminCatalog={catalog} adminGraph={graph}/> 
      <ADMSPanelProxyConnected
        adminCatalog={catalog}
        adminGraph={graph}
      />
    </>
  );
};

export default ADMSPanelProxyRoute;
